import Vue from 'vue/dist/vue.esm'
import TurbolinksAdapter from 'vue-turbolinks'
import EditableEmployeeVoiceList from '../components/EditableEmployeeVoiceList.vue'
import EditableRecruitTimeLapse from '../components/EditableRecruitTimeLapse.vue'
import EditableCompanyWorkPlace from '../components/EditableCompanyWorkPlace.vue'
import CrossAssessment from '../components/CrossAssessment.vue'
import EditableApplicantAdditionField from '../components/EditableApplicantAdditionField.vue'
import EditableApplicantDocumentList from '../components/EditableApplicantDocumentList.vue'
import RecruitCreateMessageUi from '../components/RecruitCreateMessageUi.vue'
import ApplicantEmailTemplate from '../components/ApplicantEmailTemplate/ApplicantEmailTemplate.vue'
import ScoutMessageTemplate from '../components/modal/ScoutMessageTemplate.vue'
import PersonNewsFeed from '../components/PersonNewsFeed.vue'
import PersonGenrateTextResult from '../components/PersonGenrateTextResult.vue';
import PersonAiCompanyAnalysisComments from '../components/PersonAiCompanyAnalysisComments.vue';
import PersonMemoList from '../components/PersonMemoList.vue';
import PersonMultiStepForm from '../components/PersonMultiStepForm.vue';
import PersonAiCompanyAnalysisResult from '../components/PersonAiCompanyAnalysisResult.vue';
import VueCroppie from 'vue-croppie';

Vue.use(TurbolinksAdapter)
Vue.use(VueCroppie);

// TODO refactor
document.addEventListener('turbolinks:load', () => {
  if (document.getElementById('v-editable-employee-voices') !== null) {
    const app = new Vue({
      el: '#v-editable-employee-voices',
      components: {
        EditableEmployeeVoiceList,
      }
    })
  }
  if (document.getElementById('v-editable-recruit-time-lapse') !== null) {
    const app = new Vue({
      el: '#v-editable-recruit-time-lapse',
      components: {
        EditableRecruitTimeLapse,
      }
    })
  }
  if (document.getElementById('v-editable-company-work-place') !== null) {
    const app = new Vue({
      el: '#v-editable-company-work-place',
      components: {
        EditableCompanyWorkPlace,
      }
    })
  }
  if (document.getElementById('v-cross-assessment') !== null) {
    const app = new Vue({
      el: '#v-cross-assessment',
      components: {
        CrossAssessment,
      }
    })
  }
  if (document.getElementById('v-editable-applicant-addition-field') !== null) {
    const app = new Vue({
      el: '#v-editable-applicant-addition-field',
      components: {
        EditableApplicantAdditionField,
      }
    })
  }
  if (document.getElementById('v-editable-applicant-document-list') !== null) {
    const app = new Vue({
      el: '#v-editable-applicant-document-list',
      components: {
        EditableApplicantDocumentList,
      }
    })
  }
  if (document.getElementById('v-recruit-create-message-ui') !== null) {
    window.VueRecruitCreateMessageUi = new Vue({
      el: '#v-recruit-create-message-ui',
      components: {
        RecruitCreateMessageUi,
      }
    })
  }
  if (document.getElementsByClassName('v-recruit-create-message-ui').length) {
    for (const vRecruitCreateMessageUi of document.getElementsByClassName('v-recruit-create-message-ui')) {
      const app = new Vue({
        el: vRecruitCreateMessageUi,
        components: {
          RecruitCreateMessageUi,
        }
      })
    }
  }
  if (document.getElementsByClassName('v-scout-message-template').length) {
    for (const vScoutMessageTemplate of document.getElementsByClassName('v-scout-message-template')) {
      const app = new Vue({
        el: vScoutMessageTemplate,
        components: {
          ScoutMessageTemplate,
        }
      })
    }
  }
  if (document.getElementById('v-applicant-email-template') !== null) {
    window.VueApplicantEmailTemplate = new Vue({
      el: '#v-applicant-email-template',
      components: {
        ApplicantEmailTemplate,
      }
    })
  }
  if (document.getElementById('v-person-news-feed') !== null) {
    const app = new Vue({
      el: '#v-person-news-feed',
      components: {
        PersonNewsFeed,
      }
    })
  }
  if (document.getElementById('v-person-genrate-text-result') !== null) {
    const app = new Vue({
      el: '#v-person-genrate-text-result',
      components: {
        PersonGenrateTextResult,
      }
    })
  }
  if (document.getElementById('v-person-ai-company-analysis-comments') !== null) {
    const app = new Vue({
      el: '#v-person-ai-company-analysis-comments',
      components: {
        PersonAiCompanyAnalysisComments,
      }
    })
  }
  if (document.getElementById('v-person-memo-list') !== null) {
    const app = new Vue({
      el: '#v-person-memo-list',
      components: {
        PersonMemoList,
      }
    })
  }
  if (document.getElementById('v-person-multi-step-form') !== null) {
    const app = new Vue({
      el: '#v-person-multi-step-form',
      components: {
        PersonMultiStepForm,
      }
    })
  }
  if (document.getElementById('v-person-ai-company-analysis-result') !== null) {
    const app = new Vue({
      el: '#v-person-ai-company-analysis-result',
      components: {
        PersonAiCompanyAnalysisResult,
      }
    })
  }
})
